// extracted by mini-css-extract-plugin
module.exports = {"progressContainerStyle":"ScrollIndicator-module--progressContainerStyle--2Az_G","progressBarStyle":"ScrollIndicator-module--progressBarStyle--32qlQ"};